import {useTranslation} from "react-i18next";
import OrderDashboardLayout from "./Layout/OrderDashboardLayout.jsx";
import PnoInTimeGraph from "./TablesAndGraphs/ByFilter/PnoInTimeGraph.jsx";
import OrdersInTimeGraph from "./TablesAndGraphs/ByFilter/OrdersInTimeGraph.jsx";
import React from "react";
import ClicksInTimeGraph from "./TablesAndGraphs/ByFilter/ClicksInTimeGraph.jsx";
import CpcInTimeGraph from "./TablesAndGraphs/ByFilter/CpcInTimeGraph.jsx";

export default function CampaignPerformance({project}) {

    let {t} = useTranslation();

    // noinspection JSValidateTypes
    return <OrderDashboardLayout title={t('route.campaign-comparison')} showMarketingFilters={true}>
        <PnoInTimeGraph project={project} fullWidth={true} showLegend={false}/>
        <OrdersInTimeGraph project={project} fullWidth={true} showLegend={false}/>
        <ClicksInTimeGraph project={project} fullWidth={true} showLegend={false}/>
        <CpcInTimeGraph project={project} fullWidth={true} showLegend={false}/>
    </OrderDashboardLayout>;
}